import { generateRequest } from '.';

export const Action = {
  Pay: {
    FetchWallet: 'FetchWallet',
    FetchWalletCompleted: 'FetchWalletCompleted',
    FetchWalletFailed: 'FetchWalletFailed',
    FetchLoyalty: 'FetchLoyalty',
    FetchLoyaltyCompleted: 'FetchLoyaltyCompleted',
    FetchLoyaltyFailed: 'FetchLoyaltyFailed',
    FetchOffers: 'FetchOffers',
    FetchOffersCompleted: 'FetchOffersCompleted',
    FetchOffersFailed: 'FetchOffersFailed',
  },
};

export function fetchLoyalty() {
  return generateRequest({
    endpoint: '/assets-v2/api/loyalty',
    types: [
      Action.Pay.FetchLoyalty,
      Action.Pay.FetchLoyaltyCompleted,
      Action.Pay.FetchLoyaltyFailed,
    ],
  });
}

export function fetchWallet() {
  return generateRequest({
    endpoint: '/assets-v2/api/wallet',
    types: [
      Action.Pay.FetchWallet,
      Action.Pay.FetchWalletCompleted,
      Action.Pay.FetchWalletFailed,
    ],
  });
}

export function fetchMembershipOffers() {
  return generateRequest({
    endpoint: '/assets-v2/api/membership/offers',
    types: [
      Action.Pay.FetchOffers,
      Action.Pay.FetchOffersCompleted,
      Action.Pay.FetchOffersFailed,
    ],
  });
}
